import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
  useRouteMatch
} from "react-router-dom";

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import ScrollToTop from "./Common/ScrollToTop";

import FAQ from "./Components/FAQ/faq";
import Home from "./Components/Home/home";
import About from "./Components/About/about";

import SupportPage from "./Components/Support/supportPage";

import MetaContainer from "./Components/Metadata/MetaContainer";
import DataCatalogue from "./Components/DataCatalogue/dataCatalogue";
import DataExplorer from "./Components/DataExplorer/DataExplorer";

import ForgotPasswordForm from "./Components/SignInSignUp/forgotPasswordForm";
import SignInForm from "./Components/SignInSignUp/signInForm";
import SignUpForm from "./Components/SignInSignUp/signUpForm";

import SubmitData from "./Components/SubmitData/submitPC";
import UserProfile from "./Components/Profile/userProfile";
import EditProject from "./Components/Profile/EditProject/EditProject";

import LandingPortal from "./Components/DataVisualization/VisualizationPortal/VisualizationPortal";

import PrivacyPolicy from "./Common/privacyPolicy";
import PageNotFound from "./Components/404NotFound/404NotFound";
import TermsAndConditions from "./Components/TermsAndConditions/termsAndConditions";
import Protected from "./protected";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { Buffer } from "buffer";

// Admin Components
import AdminRoute from "./adminRoute";
import AdminDashboard from "./Components/Admin/adminDashboard";
import DOIRequest from "./Components/Admin/DOIRequests/doiRequests";
import ProjectLogs from "./Components/Admin/ProjectLogs/projectLogs";
import EditComparison from "./Components/Admin/EditComparison/editComparison";
import ProjectApproval from "./Components/Admin/ProjectApproval/projectApproval";
import VisualizationApproval from "./Components/Admin/VisualizationApproval/visualizationApproval";
import UserManagement from "./Components/Admin/UserManagement/userManagement";
import LargeFileApproval from "./Components/Admin/LargeFileApproval/largeFileApproval";
import EditUser from "./Components/Admin/UserManagement/EditUser/editUserPage";
import AddFile from "./Components/Profile/EditProject/AddFile";
import Turtle from "./Components/DataCatalogue/test";
import OwlView from "./Components/DataCatalogue/TurtleView";

import LegalAcknowledgmentGate from "./Common/LegalAcknowledgmentGate";

Buffer.from("anything", "base64");
window.Buffer = window.Buffer || require("buffer").Buffer;

const VisualizationPortal = () => {
  const match = useRouteMatch();

  return (
    <div>
      <Route exact path={`${match.path}`} component={LandingPortal} />
      <Route path={`${match.path}/my-files`} component={LandingPortal} />
      <Route path={`${match.path}/information`} component={LandingPortal} />
      <Route path={`${match.path}/upload-image`} component={LandingPortal} />
      <Route path={`${match.path}/upload-pdf`} component={LandingPortal} />
      <Route path={`${match.path}/upload-video`} component={LandingPortal} />
      <Route path={`${match.path}/upload-gpx`} component={LandingPortal} />
      <Route path={`${match.path}/edit`} component={LandingPortal} />

    </div>
  );
};

const App = () => (
  <Router>
    <ScrollToTop />
    <LegalAcknowledgmentGate />

    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/data-catalogue" component={DataCatalogue} />
      <Route path="/turtle" component={Turtle} />
      <Route path="/tview" component={OwlView} />

      <Route path="/data-explorer" component={DataExplorer} />
      <Route path="/metadata-display/:id" component={MetaContainer} />

      {/* <Route path="/support" component={Support} /> */}
      <Route path="/contact" component={SupportPage} />

      <Route path="/signup" component={SignUpForm} />
      <Route path="/signin" component={SignInForm} />
      <Route path="/submit-data" component={SubmitData} />
      <Protected path="/profile">
        <UserProfile />
      </Protected>
      <Route path="/forgot-password" component={ForgotPasswordForm} />
      <Route path="/terms-and-conditions" component={TermsAndConditions} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/faq" component={FAQ} />

      <Route path="/EditProject" component={EditProject} />
      <Route path="/AddFile" component={AddFile} />
      <Route path="/visualization" component={VisualizationPortal} />

      <AdminRoute exact path="/admin" component={AdminDashboard} />

      <AdminRoute path="/admin/project-logs" component={ProjectLogs} />
      <AdminRoute path="/admin/project-approval" component={ProjectApproval} />
      <AdminRoute path="/admin/visualization-approval" component={VisualizationApproval} />
      <AdminRoute path="/admin/doi-requests" component={DOIRequest} />

      <AdminRoute exact path="/admin/user-management" component={UserManagement} />
      <AdminRoute path="/admin/user-management/edit-user/:id" component={EditUser} />
      <AdminRoute path="/admin/edit-comparison" component={EditComparison} />

      <AdminRoute path="/admin/file-approval" component={LargeFileApproval} />


      <Route path="/404" component={PageNotFound} />
      <Redirect to="/404" />
    </Switch>
  </Router>
);

export default App;